import { RequestCallbackComponent } from '@/app/features/account/request-callback/request-callback.component';
import { SharedModule } from '@/app/shared/shared.module';
import { Component, ViewChild } from '@angular/core';

@Component({
  selector: 'app-no-phenology-device-container',
  imports: [SharedModule, RequestCallbackComponent],
  templateUrl: './no-phenology-device-container.component.html',
  styleUrl: './no-phenology-device-container.component.less'
})
export class NoPhenologyDeviceContainerComponent {
  @ViewChild('requestCallback') requestCallback!: RequestCallbackComponent;

  loading = false;

  openAddDeviceModal() { }
  openRequestCallModal() {
    this.requestCallback.showRequestCallback();
  }
}
